// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3TJRt","ranges":"BmiRanges_ranges__1ommz"};